module.exports = __webpack_public_path__ + "img/9788934989073.551de704.jpg";